export default __webpack_public_path__ + "static/media/CenterContentBlock.8f86a0c8.png";